<!-- Launched from the shared assistance launcher (app-assistance-launcher). -->
@defer (when feedbackFacade.isOpen()) {
  <app-feedback-dialog></app-feedback-dialog>
}
